import React, { Component } from "react";
import axios from "axios";

import "./partnerDetails.scss";
import Footer from "../shared/footer";
import { env } from "../shared/environment";
import SalomCardForm from "../components/salomCardForm";
import MobileNavBar from "../shared/topBar/MobileNavBar/MobileNavBar";
import MainNavBar from "../shared/topBar/MainNavBar/MainNavBar";
import PartnerDetailsBanner from "./components/partnerDetailsBanner";
import LoanСonditions from "./components/loanСonditions";
import ShopContact from "./components/shopContact";
import ShopContactSalomCard from "./components/shopContactSalomCard";

class PartnerDetails extends Component {
    baseUrl = env.baseUrl;
    constructor(props) {
        super(props);

        this.state = {
            windowWidth: window.innerWidth,
            link: props.match.params.id,
            partner: {},
            categories: [],
            contacts: [],
            conditionsCurrency: [],
            conditions: [],
            isBackDrop: false
        };
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);

        let self = this;
        axios
            .get(`${this.baseUrl}public/partner/${this.state.link}`)
            .then(response => {
                if (response.data.code === 200) {
                    self.setState({
                        partner: response.data.payload
                    });
                    axios
                        .all([
                            axios.get(
                                `${this.baseUrl}public/partners/categories/${this.state.partner.id}`
                            ),
                            axios.get(
                                `${this.baseUrl}public/partners/contacts/${this.state.partner.id}`
                            ),
                            axios.get(
                                `${this.baseUrl}public/partners/conditionsCurrency/${this.state.partner.id}`
                            ),
                            axios.get(
                                `${this.baseUrl}public/partners/conditions/${this.state.partner.id}`
                            )
                        ])
                        .then(
                            axios.spread(function (
                                categories,
                                contacts,
                                conditionsCurrency,
                                conditions
                            ) {
                                self.setState({
                                    categories: categories.data.payload,
                                    contacts: contacts.data.payload,
                                    conditionsCurrency: conditionsCurrency.data.payload,
                                    conditions: conditions.data.payload
                                });
                            })
                        )
                        .catch(error => console.log("err: ", error));
                }
            })
            .catch(error => console.log("err: ", error));
    }

    updateDimensions() {
        this.setState({ windowWidth: window.innerWidth });
    };

    handleBackDrop(event) {
        this.setState({
            isBackDrop: event
        });
    }

    render() {
        let categories = [];
        let conditions = {};
        let imgSrc = '';
        let contacts = [];
        let alifshopLink = '';
        let description = '';

        if (this.props) {
            categories = this.state.categories;
            conditions = this.state.conditions;
            imgSrc = this.state.partner.imagePath;
            contacts = this.state.contacts;
            alifshopLink = this.state.partner.alifshopLink
            description = this.state.partner.description
        }

        return (
            <div>
                <div className="partner-details">
                    {this.state.windowWidth <= 1200 ? <MobileNavBar /> : <MainNavBar />}
                    <PartnerDetailsBanner windowWidth={this.state.windowWidth} contacts={contacts} />
                    <ShopContact windowWidth={this.state.windowWidth}
                        categories={categories}
                        img={imgSrc}
                        contacts={contacts}
                        alifshopLink={alifshopLink}
                        description={description} />
                    <LoanСonditions params={conditions} />
                    <ShopContactSalomCard windowWidth={this.state.windowWidth} />
                    <Footer windowWidth={this.state.windowWidth} />
                </div>
            </div>
        );
    }
}

export default PartnerDetails;
